import { hubHeaders } from '@precisionpros/game-ui';
import { API_URL } from '../config/environment';

const request = async (path, options = {}) => {
  const headers = { ...hubHeaders(), ...(options.body ? { 'Content-Type': 'application/json' } : {}) };
  const response = await fetch(`${API_URL}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || `Request failed (${response.status}).`);
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
};

export const fetchDailyPuzzle = () => request('/puzzle/today/');
export const fetchTodaySession = () => request('/sessions/today/');
export const startDailySession = () => request('/sessions/start/', {
  method: 'POST',
  body: JSON.stringify({}),
});
export const performSessionAction = (sessionId, action, row, column) => request(
  `/sessions/${sessionId}/action/`,
  {
    method: 'POST',
    body: JSON.stringify({ action, row, column }),
  },
);
